import { updateAccountUI } from './account.js';
import { syncLoadLS } from './sync.js';
import { PLUME_CONFIG } from '../config.js';
import { t } from '../i18n/index.js';

export let CLOUD={cfg:null,auth:null,user:null,status:'off',t:null,mfa:null,rev:null,dirty:false,pushing:false,muted:false,poll:null,checking:false,ctx:null,org:null};

export function cloudLoadLS(){
  const bc=PLUME_CONFIG;
  if(bc.SUPABASE_URL&&bc.SUPABASE_ANON_KEY)CLOUD.cfg={url:bc.SUPABASE_URL,key:bc.SUPABASE_ANON_KEY,baked:true};
  else{try{CLOUD.cfg=JSON.parse(localStorage.getItem('plume.cloud'))||null}catch(e){CLOUD.cfg=null}}
  try{CLOUD.auth=JSON.parse(localStorage.getItem('plume.auth'))||null}catch(e){CLOUD.auth=null}
  syncLoadLS();
}
export function cloudPersistLS(){
  if(CLOUD.cfg&&!CLOUD.cfg.baked)localStorage.setItem('plume.cloud',JSON.stringify(CLOUD.cfg));
  if(CLOUD.auth)localStorage.setItem('plume.auth',JSON.stringify(CLOUD.auth));else localStorage.removeItem('plume.auth');
}
export function cloudOn(){return !!(CLOUD.cfg&&CLOUD.cfg.url&&CLOUD.cfg.key)}
export function loggedIn(){return cloudOn()&&!!(CLOUD.auth&&CLOUD.auth.at)}
export function sbBase(u){
  let s=String(u||'').trim().replace(/\/+$/,'');
  if(!/^https?:\/\//.test(s))s='https://'+s;
  try{const u2=new URL(s);return u2.protocol+'//'+u2.host}catch(e){return s.replace(/(https?:\/\/[^/]+).*$/,'$1')}
}
export function sbUrl(p){return sbBase(CLOUD.cfg.url)+p}
export function friendlyErr(m){
  m=String(m||'');
  if(/Invalid login credentials/i.test(m))return t('auth.eBad');
  if(/already registered|already been registered/i.test(m))return t('auth.eExists');
  if(/Email not confirmed/i.test(m))return t('auth.eUnconfirmed');
  if(/rate limit|too many/i.test(m))return t('auth.eRate');
  if(/Invalid TOTP|invalid code|expired|Token has expired/i.test(m))return t('auth.eCode');
  if(/Failed to fetch|NetworkError|network/i.test(m))return t('auth.eNet');
  return m;
}
export async function sbFetch(path,opts={},noAuth){
  const h={apikey:CLOUD.cfg.key,'Content-Type':'application/json',...(opts.headers||{})};
  if(!noAuth&&CLOUD.auth&&CLOUD.auth.at)h.Authorization='Bearer '+CLOUD.auth.at;
  const r=await fetch(sbUrl(path),{...opts,headers:h});
  let d=null;try{d=await r.json()}catch(e){}
  if(!r.ok)throw new Error((d&&(d.msg||d.error_description||d.message||d.error))||('HTTP '+r.status));
  return d;
}
export function setAuth(d){
  if(!d||!d.access_token)return false;
  const md=(d.user&&d.user.user_metadata)||{};
  CLOUD.auth={
    at:d.access_token,rt:d.refresh_token,
    exp:Date.now()+(((d.expires_in||3600)-90)*1000),
    email:(d.user&&d.user.email)||(CLOUD.auth&&CLOUD.auth.email)||'',
    uid:(d.user&&d.user.id)||(CLOUD.auth&&CLOUD.auth.uid)||'',
    name:md.full_name||md.name||(CLOUD.auth&&CLOUD.auth.name)||'',
    pic:md.avatar_url||md.picture||(CLOUD.auth&&CLOUD.auth.pic)||''
  };
  if(d.user)CLOUD.user=d.user;
  cloudPersistLS();updateAccountUI();
  return true;
}
export async function sbRefresh(){
  const d=await sbFetch('/auth/v1/token?grant_type=refresh_token',{method:'POST',body:JSON.stringify({refresh_token:CLOUD.auth.rt})},true);
  if(!setAuth(d))throw new Error('refresh failed');
}
export async function sbRest(path,opts={}){
  if(!loggedIn())throw new Error('not signed in');
  if(Date.now()>CLOUD.auth.exp)await sbRefresh();
  const r=await fetch(sbUrl('/rest/v1/'+path),{...opts,headers:{apikey:CLOUD.cfg.key,Authorization:'Bearer '+CLOUD.auth.at,'Content-Type':'application/json',...(opts.headers||{})}});
  if(r.status===401&&!opts.__r){await sbRefresh();return sbRest(path,{...opts,__r:true})}
  if(!r.ok){let m='';try{m=(await r.json()).message||''}catch(e){}throw new Error('HTTP '+r.status+(m?' '+m:''))}
  return r;
}
export async function loadUser(){CLOUD.user=await sbFetch('/auth/v1/user');updateAccountUI();return CLOUD.user}

/* ---------------- sync: cloud is the source of truth ---------------- */
